import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, PlayCircle } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { useLT } from "./sections";

export default function DemoButton({ variant = "hero", className = "" }) {
  const t = useLT();
  const { demoLogin } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await demoLogin();
      nav("/dashboard");
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  const styles = variant === "nav"
    ? "hidden h-9 items-center gap-1.5 whitespace-nowrap rounded-full border border-[#D4AF37]/40 px-3.5 text-xs font-bold text-[#F0D77A] hover:bg-[#D4AF37]/10 xl:inline-flex"
    : "inline-flex h-12 items-center gap-2 rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10 px-6 text-sm font-bold text-[#F0D77A] transition-colors hover:bg-[#D4AF37]/20";
  return (
    <button type="button" data-testid={`demo-${variant}-btn`} onClick={go} disabled={busy} className={`${styles} disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <PlayCircle className="h-4 w-4" />}
      {busy ? t("demoBusy") : variant === "nav" ? t("navDemo") : t("demoBtn")}
    </button>
  );
}
